import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import FormElement from "components/FormElement";
import { requestFields } from "helpers/BatterySupplierHelper";
import { formatSuppliersList, supplierTypes } from "helpers/SupplierHelper";
import { setValue } from "actions/request";
import { fetchCellModels } from "actions/suppliers";

class SelectRecognitionSupplier extends React.Component {
  requestField = requestFields.supplier;

  componentWillUnmount() {
    this.props.setValue(this.requestField, "");
  }

  onChange = event => {
    const { setValue, fetchCellModels, request, suppliers } = this.props;
    const supplierId = Number(event.target.value);

    // reset batteryModel value
    setValue(requestFields.model, "");
    setValue(requestFields.modelId, "");
    setValue(requestFields.modelName, "");
    setValue(requestFields.cellRequestId, "");

    // reset batteryModelOption value
    setValue(requestFields.modelOption, undefined);

    const supplier = _.find(suppliers.cells, cell => cell.value === supplierId);

    if (supplier) {
      // set batterySupplier values
      setValue(this.requestField, supplierId);
      setValue(requestFields.supplierId, supplierId);
      setValue(requestFields.supplierName, supplier.title);

      // fetch related models
      fetchCellModels(supplierId, request.ieee);
    } else {
      setValue(this.requestField, null);
      setValue(requestFields.supplierId, null);
      setValue(requestFields.supplierName, null);
    }
  };

  render() {
    const { cells } = this.props.suppliers;

    if (!cells || !cells.length) return null;

    return (
      <FormElement
        type="select"
        id={this.requestField}
        label="Cell Supplier"
        value={this.props.request[this.requestField] || 0}
        onChange={this.onChange}
        options={formatSuppliersList(cells, supplierTypes.cell)}
      />
    );
  }
}

function mapStateToProps({ request, suppliers }) {
  return { request, suppliers };
}

export default connect(mapStateToProps, {
  setValue,
  fetchCellModels
})(SelectRecognitionSupplier);
